{
  "nav": {
    "login": "Մուտք"
  },
  "hero": {
    "badge": "Հաճախելիության հաշվառում դեմքի/մատնահետքի ճանաչմամբ",
    "title": "Աշխատակիցների հաճախելիությունը և աշխատավարձը՝ ավտոմատ",
    "subtitle": "Դեմքի/մատնահետքի ճանաչմամբ տերմինալ մուտքի մոտ, մուտք/ելքեր իրական ժամանակում, տաբել, արձակուրդներ և աշխատավարձի հաշվետվություններ՝ մեկ հարթակում։",
    "cta": "Ամրագրել ցուցադրություն",
    "ctaSecondary": "Մուտք",
    "mock": {
      "title": "Այսօր",
      "checkedIn": "Ներկա է",
      "late": "Ուշացում",
      "onVacation": "Արձակուրդ"
    }
  },
  "features": {
    "title": "Այն ամենը, ինչ պետք է թիմը կառավարելու համար",
    "subtitle": "Տերմինալին ուղղված առաջին հայացքից մինչև աշխատավարձի վերջնական թիվը՝ առանց աղյուսակների ու ձեռքով հաշվարկի։",
    "items": {
      "terminal": {
        "title": "Դեմքի/մատնահետքի ճանաչում",
        "text": "Աշխատակիցը նշվում է մեկ հայացքով կամ մատնահետքով՝ առանց քարտերի և հերթերի։"
      },
      "live": {
        "title": "Մուտք/ելքեր իրական ժամանակում",
        "text": "Յուրաքանչյուր մուտք և ելք ակնթարթորեն երևում է հարթակում։ Ուշացումները տեսանելի են անմիջապես։"
      },
      "reports": {
        "title": "Տաբել և աշխատավարձ",
        "text": "Հաճախելիության աղյուսակ, ուշացումների պահումներ, արտաժամյա աշխատանք, կանխավճարներ և վերջնական աշխատավարձ՝ ավտոմատ հաշվարկով։"
      },
      "timeoff": {
        "title": "Արձակուրդներ և բացակայություններ",
        "text": "Արձակուրդները, հիվանդության օրերը և գործուղումները պլանավորվում են նախապես և հաշվի են առնվում ամեն հաշվարկում։"
      },
      "notifications": {
        "title": "Ծանուցումներ Telegram-ում",
        "text": "Մուտքերի և ուշացումների մասին ծանուցումները ստացեք ուղիղ ձեր Telegram խմբում։"
      },
      "languages": {
        "title": "Երեք լեզու",
        "text": "Ամբողջ ինտերֆեյսը հասանելի է հայերեն, ռուսերեն և անգլերեն։"
      }
    }
  },
  "how": {
    "title": "Ինչպես է աշխատում",
    "steps": {
      "one": {
        "title": "Տեղադրում ենք տերմինալը",
        "text": "Դեմքի/մատնահետքի ճանաչմամբ տերմինալը տեղադրվում է մուտքի մոտ և միանում հարթակին մի քանի րոպեում։"
      },
      "two": {
        "title": "Աշխատակիցները նշվում են հայացքով կամ մատնահետքով",
        "text": "Յուրաքանչյուր մուտք և ելք ճանաչվում ու գրանցվում է ավտոմատ՝ առանց քարտի կամ ստորագրության։"
      },
      "three": {
        "title": "Դուք ստանում եք թվերը",
        "text": "Վահանակները, տաբելները և աշխատավարձի հաշվետվությունները միշտ արդիական են և պատրաստ արտահանման։"
      }
    }
  },
  "book": {
    "title": "Ամրագրել ցուցադրություն",
    "subtitle": "Թողեք ձեր կոնտակտային տվյալները՝ մենք կկապվենք ձեզ հետ և կցուցադրենք հարթակը գործողության մեջ։",
    "form": {
      "name": "Ձեր անունը",
      "namePlaceholder": "Անուն Ազգանուն",
      "phone": "Հեռախոս",
      "phonePlaceholder": "+374 ...",
      "submit": "Ուղարկել հայտը",
      "sending": "Ուղարկվում է…",
      "required": "Խնդրում ենք լրացնել անունը և հեռախոսահամարը։",
      "success": "Շնորհակալություն։ Հայտն ընդունված է — շուտով կկապվենք ձեզ հետ։",
      "successAnother": "Ուղարկել ևս մեկ հայտ",
      "error": "Չհաջողվեց ուղարկել հայտը։ Փորձեք կրկին կամ կապվեք մեզ հետ ուղիղ։"
    },
    "contactTitle": "Կամ կապվեք մեզ հետ ուղիղ",
    "emailLabel": "Էլ. փոստ",
    "phoneLabel": "Հեռախոս"
  },
  "footer": {
    "rights": "Բոլոր իրավունքները պաշտպանված են։"
  },
  "seo": {
    "title": "Աշխատակիցների կառավարման հարթակ — հաճախելիություն, տաբել, աշխատավարձ",
    "description": "Դեմքի/մատնահետքի ճանաչմամբ տերմինալ, մուտք/ելքերի հաշվառում իրական ժամանակում, տաբել, արձակուրդներ, աշխատավարձի հաշվարկ և Telegram ծանուցումներ՝ մեկ հարթակում։ Ամրագրեք ցուցադրություն։"
  }
}
